module.exports = {
  // Tiny KeyboardEvent.code polyfill.
  KEYCODE_TO_CODE: {
    38: "ArrowUp",
    37: "ArrowLeft",
    40: "ArrowDown",
    39: "ArrowRight",
    87: "KeyW",
    65: "KeyA",
    83: "KeyS",
    68: "KeyD",
  },
};
